import Papa from 'papaparse';

export type QuestionType = 'Radio' | 'Text';

export interface HealthCheckQuestion {
    section: string;
    id: string;
    text: string;
    type: QuestionType;
    options: string[];
    action: string;
}

interface CsvRow {
    Section: string;
    QuestionNumber: string;
    QuestionText: string;
    ResponseOptions?: string;
    Action: string;
}

export const loadQuestions = async (): Promise<HealthCheckQuestion[]> => {
    return new Promise((resolve, reject) => {
        Papa.parse<CsvRow>('/healthcheck/questions.csv', {
            download: true,
            header: true,
            skipEmptyLines: true,
            complete: (results) => {
                if (results.errors.length > 0) {
                    console.error('CSV Parse Errors:', results.errors);
                    reject(results.errors);
                    return;
                }

                const questions: HealthCheckQuestion[] = results.data.map((row) => {
                    // "Yes;No" → Radio with options; "FreeText" / "" → Text
                    let type: QuestionType = 'Radio';
                    let options: string[] = [];

                    const responseOptions = row.ResponseOptions ? row.ResponseOptions.trim() : '';

                    if (!responseOptions || responseOptions.toLowerCase() === 'freetext') {
                        type = 'Text';
                    } else {
                        type = 'Radio';
                        options = responseOptions.split(';').map((o) => o.trim());
                    }

                    return {
                        section: row.Section,
                        id: row.QuestionNumber,
                        text: row.QuestionText,
                        type,
                        options,
                        action: row.Action,
                    };
                });
                resolve(questions);
            },
            error: (error) => {
                reject(error);
            },
        });
    });
};
